import React, {Component} from 'react';
import {BrowserRouter, Switch, Route} from 'react-router-dom';
import fetchIntercept from 'fetch-intercept';
import {tokenRegister} from "./services/tokenRegister";
import RouterWrapper from "./components/router-wrapper/component";
import {userRegister} from "./services/userRegister";
import { Redirect } from 'react-router-dom';
import TemplateVideoBasic from "./templates/videos/basic/component";
import TemplateCarouselBasicFirst from "./templates/carousel/basic/first/component";
import TemplateCarouselBasicLast from "./templates/carousel/basic/last/component";
import TemplateCarouselBasicCenter from "./templates/carousel/basic/center/component";
import TemplateCarouselBasicCenterBadge from "./templates/carousel/basic/center-badge/component";
import TemplateCarouselPropertyFirst from "./templates/carousel/property/first/component";
import BoosterLead from "./pages/booster-lead/component";
import {agentRegister} from "./services/agentRegister";

class Main extends Component {

    constructor(props) {
        super(props);
        this.state = {};
    };

    componentWillMount(){
        this._setInterceptor();
    }

    _setInterceptor(){
        const unregister = fetchIntercept.register({
            request: function (url, config) {
                return [url, config];
            },
            requestError: function (error) {
                return Promise.reject(error);
            },
            response: function (response) {
                if(response.headers.get('X-Jwt-Token')){
                    tokenRegister.set(response.headers.get('X-Jwt-Token'));
                }
                if(response.status === 200){
                    return response;
                }else if(response.status === 401){
                    userRegister.remove();
                    agentRegister.remove();
                    tokenRegister.remove();
                    return Promise.reject(response);
                } else{
                    return Promise.reject(response);
                }
            },
            responseError: function (error) {
                return Promise.reject(error);
            }
        });
    }

    _channel(){
        if(window.location.href.indexOf("propertybooster") !== -1){
            return "propertybooster";
        }else if(window.location.href.indexOf("boostabostad") !== -1){
            return "boostabostad";
        }
    }

    render() {
        return (
            <BrowserRouter>
                <Switch>
                    <Route exact path={'/templates/video/basic'} component={TemplateVideoBasic}/>
                    <Route exact path={'/templates/carousel/basic/first'} component={TemplateCarouselBasicFirst}/>
                    <Route exact path={'/templates/carousel/basic/last'} component={TemplateCarouselBasicLast}/>
                    <Route exact path={'/templates/carousel/basic/center'} component={TemplateCarouselBasicCenter}/>
                    <Route exact path={'/templates/carousel/basic/center-badge'} component={TemplateCarouselBasicCenterBadge}/>

                    <Route exact path={'/templates/carousel/property/first'} component={TemplateCarouselPropertyFirst}/>

                    <Route exact path={'/lead/:id'} component={BoosterLead}/>

                    <Route path={"/:market/:lang"} component={RouterWrapper}/>

                    {
                        this._channel() === "propertybooster" &&
                        <Redirect to={"/ae/en"} />
                    }
                    {
                        this._channel() === "boostabostad" &&
                        <Redirect to={"/se/sv"} />
                    }
                    {
                        <Redirect to={"/ae/en"} />
                    }

                </Switch>
            </BrowserRouter>
        )
    }

}

export default Main


// WEBPACK FOOTER //
// ./src/main.js